export default __webpack_public_path__ + "static/media/Publication.bc3b96f4.svg";